module.exports = __webpack_public_path__ + "static/media/click.28aaa872.svg";